export default __webpack_public_path__ + "static/11256-a2f392834d1c63aee5e3d03b30ec1cd5.jpg";